const LogoMark = ({ size = 44, dark = false, className = "" }) => {
  const pine = dark ? "#F7F5F0" : "#0A2E20";
  return (
    <svg
      viewBox="0 0 100 100"
      width={size}
      height={size}
      className={className}
      data-testid="pk-monogram"
      role="img"
      aria-label="PK monogram"
    >
      <path
        d="M 80 20 A 42 42 0 1 0 80 80"
        fill="none"
        stroke={pine}
        strokeWidth="5"
        strokeLinecap="round"
      />
      <path
        d="M 20 80 A 42 42 0 0 1 20 20"
        fill="none"
        stroke="#D4AF37"
        strokeWidth="5"
        strokeLinecap="round"
      />
      <text
        x="50"
        y="66"
        textAnchor="middle"
        fontFamily="'Cormorant Garamond', Georgia, serif"
        fontWeight="600"
        fontSize="46"
        fill={pine}
      >
        PK
      </text>
    </svg>
  );
};

export default LogoMark;
